import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { kitFetch } from "@ekultur/fetch";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import Settings from "../Settings";
import enCommon from "./en/common.json";
import svCommon from "./sv/common.json";
import noCommon from "./no/common.json";
import nnCommon from "./nn/common.json";
/* eslint-disable unused-imports/no-unused-imports, @typescript-eslint/no-unused-vars */
import deCommon from "./de/common.json";
import esCommon from "./es/common.json";
import frCommon from "./fr/common.json";
/* eslint-enable unused-imports/no-unused-imports, @typescript-eslint/no-unused-vars */
import { getLanguageCode } from "@/utils/obj";

export const resources = {
  en: {
    common: enCommon,
  },
  no: {
    common: noCommon,
  },
  sv: {
    common: svCommon,
  },
  nn: {
    common: nnCommon,
  },
  // fr: {
  //   common: frCommon,
  // },
  // de: {
  //   common: deCommon,
  // },
  // es: {
  //   common: esCommon,
  // },
};

//Flatten translation objects to support both flat and nested keys
const flattenTranslations = (obj: any, prefix = "", res: any = {}) => {
  for (const key in obj) {
    const propName = prefix ? `${prefix}.${key}` : key;
    // If it's an object (and not null/array), recurse
    if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
      flattenTranslations(obj[key], propName, res);
    } else {
      res[propName] = obj[key];
    }
  }
  return res;
};

const flattenedLocalResources = Object.keys(resources as any).reduce((acc: any, lang) => {
  acc[lang] = {};
  Object.keys((resources as any)[lang]).forEach((ns) => {
    acc[lang][ns] = flattenTranslations((resources as any)[lang][ns]);
  });
  return acc;
}, {});

const hasToken = !!localStorage.getItem("kit.access_token");
const selectedLanguage = localStorage.getItem("i18nextLng");
const initialLocalePromise: Promise<string | undefined> =
  hasToken && !selectedLanguage && Settings.EKULTUR_USERDATA_URL.length > 0
    ? kitFetch(Settings.EKULTUR_USERDATA_URL)
        .then((res: any) => {
          const foundLocale: string | null = res?.locale ?? null;
          return !!foundLocale ? getLanguageCode(foundLocale) : undefined;
        })
        .catch((err: any) => {
          console.error("[i18n] userData fetch failed:", err);
          return undefined;
        })
    : Promise.resolve(undefined);

i18n
  .use(new LanguageDetector())
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
    },
    fallbackLng: (code) => getLanguageCode(code),
    ns: ["common", "db"],
    defaultNS: "common",
    lowerCaseLng: true,
    cleanCode: true,
    debug: Settings.DEBUG_I18NEXT,
    resources: flattenedLocalResources,
    returnObjects: false,
    keySeparator: false,
    nsSeparator: ":",

    backend: {
      loadPath:
        `${Settings.TRANSLATIONS_API_ENDPOINT}{{lng}}.json` ||
        `${Settings.API_BASE_HOST}/admin/api/translations/{{lng}}.json`,
      parse: (data) => {
        const json = JSON.parse(data);
        return flattenTranslations(json);
      },
    },
  })
  // reloadResources must be called for HttpBackend to fetch the db translations
  .then(() => i18n.reloadResources(null, ["db"], () => {}));

initialLocalePromise.then((locale) => {
  if (locale) {
    i18n.changeLanguage(locale);
  }
});

export default i18n;
